import { apiV2, errorHandler } from "./index";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import {
  API_ERROR,
  FETCH_RECOMMENDED_LIST,
  FETCH_RECOMMENDED_LIST_START,
  FETCH_RECOMMENDED_LIST_ERROR,
  FETCH_POPULAR_LIST,
  FETCH_POPULAR_LIST_START,
  FETCH_POPULAR_LIST_ERROR,
  FETCH_TOPIC_SESSION_LIST,
  FETCH_TOPIC_SESSION_LIST_START,
  FETCH_TOPIC_SESSION_LIST_ERROR,
} from "../constants/ActionTypes";

// ---------- Recommended list ----------

export function fetchRecommendedList() {
  return function (dispatch) {
    dispatch({ type: FETCH_RECOMMENDED_LIST_START });
    return apiV2
      .get("/sessions/recommended-list")
      .then(response => {
        dispatch({
          type: FETCH_RECOMMENDED_LIST,
          payload: response.data.objects || [],
        });
        return response.data.objects || [];
      })
      .catch(error => {
        dispatch({ type: FETCH_RECOMMENDED_LIST_ERROR });
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function replaceRecommendedList(sessionIds) {
  return function (dispatch) {
    return apiV2
      .put("/sessions/recommended-list", { session_ids: sessionIds })
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        });
        // Refresh so we have canonical ordering / resource shape after save.
        // Swallow refresh errors here so a successful save isn't reported as a
        // failure; fetchRecommendedList already surfaces its own error to the user.
        return dispatch(fetchRecommendedList())
          .catch(() => {})
          .then(() => true);
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

// ---------- Popular list ----------

export function fetchPopularList() {
  return function (dispatch) {
    dispatch({ type: FETCH_POPULAR_LIST_START });
    return apiV2
      .get("/sessions/popular-list")
      .then(response => {
        dispatch({
          type: FETCH_POPULAR_LIST,
          payload: response.data.objects || [],
        });
        return response.data.objects || [];
      })
      .catch(error => {
        dispatch({ type: FETCH_POPULAR_LIST_ERROR });
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function replacePopularList(sessionIds) {
  return function (dispatch) {
    return apiV2
      .put("/sessions/popular-list", { session_ids: sessionIds })
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        });
        return dispatch(fetchPopularList())
          .catch(() => {})
          .then(() => true);
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

// ---------- Topic (goal-content) session lists ----------

// Monotonic id per fetch, so the reducer can drop superseded completions.
let topicSessionListRequestId = 0;

export function fetchTopicSessionList(slug) {
  return function (dispatch) {
    const requestId = ++topicSessionListRequestId;
    dispatch({ type: FETCH_TOPIC_SESSION_LIST_START, slug, requestId });
    return apiV2
      .get(`/admin/goal-content/${encodeURIComponent(slug)}/sessions`)
      .then(response => {
        const objects = response.data.objects || [];
        dispatch({ type: FETCH_TOPIC_SESSION_LIST, slug, requestId, payload: objects });
        return objects;
      })
      .catch(error => {
        dispatch({ type: FETCH_TOPIC_SESSION_LIST_ERROR, slug, requestId });
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}

export function replaceTopicSessionList(slug, sessionIds) {
  return function (dispatch) {
    return apiV2
      .put(`/admin/goal-content/${encodeURIComponent(slug)}/sessions`, { session_ids: sessionIds })
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        });
        return dispatch(fetchTopicSessionList(slug))
          .catch(() => {})
          .then(() => true);
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
        throw error;
      });
  };
}
